import { useMemo, useState } from 'react'

import { cn } from '@/lib/utils'
import { parseReplyBody } from './replyBody'

/**
 * The body of an inbox message: what the person typed, with the thread quoted
 * under it folded behind a toggle and its ">" marks removed (AB#22441).
 *
 * Mount it with `key={message.id}` so the toggle closes when another message is
 * selected.
 */
export function ReplyBodyView({ body }: { body?: string | null }) {
  const { reply, quoted } = useMemo(() => parseReplyBody(body), [body])
  const [showQuoted, setShowQuoted] = useState(false)

  return (
    <div>
      <p
        className="text-foreground dark:text-[#d0d6e0] whitespace-pre-wrap"
        style={{ fontSize: '13px', letterSpacing: '-0.1px', lineHeight: 1.6 }}
      >
        {reply || '(No text content)'}
      </p>

      {quoted && (
        <div className="mt-3">
          <button
            type="button"
            onClick={() => setShowQuoted((v) => !v)}
            aria-expanded={showQuoted}
            className={cn(
              'rounded px-1.5 py-0.5 text-[11px] font-medium transition-colors',
              'text-muted-foreground hover:text-foreground hover:bg-muted/60',
              'dark:text-[#8a8f98] dark:hover:text-[#d0d6e0] dark:hover:bg-white/[0.06]',
            )}
          >
            {showQuoted ? 'Hide quoted text' : 'Show quoted text'}
          </button>
          {showQuoted && (
            <p
              className={cn(
                'mt-2 border-l-2 pl-3 whitespace-pre-wrap',
                'border-border text-muted-foreground',
                'dark:border-white/[0.14] dark:text-[#8a8f98]',
              )}
              style={{ fontSize: '12px', letterSpacing: '-0.1px', lineHeight: 1.55 }}
            >
              {quoted}
            </p>
          )}
        </div>
      )}
    </div>
  )
}
